import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from 'stores/AppStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import { VallourecServicesDataContext } from 'stores/VallourecServicesDataStore'
import { LoadingOverlay, FlexView, Icon, Card } from 'components/common'
import { toast } from 'react-toastify'
import { RiUpload2Line, RiDownloadLine } from 'react-icons/ri'
import styled from 'styled-components'
import Dropzone from 'react-dropzone'

const UploadButton = styled.div`
  display: flex;
  min-width: 116px;
  align-items: center;
  justify-content: center;
  background: #59CBE4;
  border-radius: 8px;
  padding: 4px 8px;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;

  box-shadow:0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132);

  &:hover{
    box-shadow:0px 1.2px 3.6px rgba(0, 0, 0, 0.108), 0px 6.4px 14.4px rgba(0, 0, 0, 0.132);
  }
  display: flex;
  justify-content: space-between;
  p {
    padding-left: 8px;
    font-size: 14px;
    font-weight: bold;
    margin: 0px 4px 0px 0px;
  }
`

const DisabledUploadButton = styled.div`
  display: flex;
  min-width: 116px;
  align-items: center;
  justify-content: center;
  background: lightgrey;
  border-radius: 8px;
  padding: 4px 8px;
  color: #fff;
  transition: 0.2s;

  box-shadow:0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132);

  display: flex;
  justify-content: space-between;
  p {
    padding-left: 8px;
    font-size: 14px;
    font-weight: bold;
    margin: 0px 4px 0px 0px;
  }
`

const DownloadButton = styled.div`
  display: flex;
  min-width: 176px;
  align-items: center;
  justify-content: center;
  background: #59e4b3;
  border-radius: 8px;
  padding: 4px 8px;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;

  box-shadow:0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132);

  &:hover{
    box-shadow:0px 1.2px 3.6px rgba(0, 0, 0, 0.108), 0px 6.4px 14.4px rgba(0, 0, 0, 0.132);
  }

  display: flex;
  justify-content: space-between;
  p {
    padding-left: 8px;
    font-size: 14px;
    font-weight: bold;
    margin: 0px 4px 0px 0px;
  }
`
const VallourecServicesManualDataPage = () => {

  const DEFAULT_URL = "vallourec-services-manual-data"
  const { t } = useTranslation()
  const { registryLog } = useContext(UserContext)
  const { setPageSubtitle } = useContext(AppContext)
  const { uploadManualData } = useContext(VallourecServicesDataContext)
  const [loading, setLoading] = useState(true)
  const [selectedFile, setSelectedFile] = useState(null)

  useEffect(() => {
    setPageSubtitle(t('vallourecServicesManualData.pageTitle'))
  }, [setPageSubtitle, t])

  useEffect(() => {
    //registryLogOld('Page In', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'navigation', 'page_in')
    setLoading(false)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onDownloadClick = () => {
    //registryLogOld('Download Template', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'download', 'template')
    window.open('/docs/vallourecserviceapp-manual-upload-template.xlsx', '_blank')
  }

  const onFileSelect = (acceptedFiles) => {
    //registryLogOld('Select File', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'click', 'select_file')
    setSelectedFile(acceptedFiles[0])
  }

  const onUploadClick = () => {
    registryLog(DEFAULT_URL, 'click', 'upload')
    //registryLogOld('Upload', DEFAULT_URL)
    const reader = new FileReader()
    reader.readAsArrayBuffer(selectedFile)

    reader.onload = async (e) => {
      const byteArray = (e.target).result
      const base64 = transformFileToBase64(byteArray)

      uploadManualData({ upload: { data: base64 } }).then(() => {
        toast.success(t('vallourecServicesManualData.uploadSuccess'))
        setSelectedFile(null)
      }).catch(e => {
        toast.error(e.message ? t(e.message) : e.errorMessage ? t(e.errorMessage) : JSON.stringify(e))
        console.debug(e)
      }).finally(() => setLoading(false))
    }
  }

  const transformFileToBase64 = (content) => {
    let binary = ''
    const bytes = new Uint8Array(content)
    const len = bytes.byteLength
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    const base64 = btoa(binary)
    return base64
  }

  return <FlexView flex="1" position="relative" alignSelf="stretch">
    <FlexView flexDirection="row" alignItems="center" justifyContent="flex-start" alignSelf="stretch" margin="36px 200px 10px">
      <Icon name='report' width="30px" height="36px"></Icon>
      <FlexView fontSize="big" fontWeight="bold" color="gray" margin="0px 8px 0px 8px">{t('vallourecServicesManualData.pageSubtitle')}</FlexView>
    </FlexView>

    <Card margin="15px 200px" height="250px" flexDirection="row" justifyContent="stretch" alignSelf="stretch" alignItems="stretch">
      <Dropzone accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" maxFiles={1} multiple={false} maxSize={6000000} onDrop={acceptedFiles => onFileSelect(acceptedFiles)}>
        {({ getRootProps, getInputProps }) => (
          <section style={{ flex: '1 0', display: 'flex', alignItems: 'stretch', justifyContent: 'stretch' }}>
            <div style={{ flex: '1 0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} {...getRootProps()}>
              <input {...getInputProps()} />
              <p style={{ fontSize: '20px', fontWeight: 700, color: 'gray' }}>{selectedFile ? selectedFile.path : t('vallourecServicesManualData.uploadText')}</p>
            </div>
          </section>
        )}
      </Dropzone>
    </Card>

    <FlexView margin="15px 200px" flexDirection="row" justifyContent="space-between" alignSelf="stretch">
      <DownloadButton onClick={onDownloadClick}>
        <p>{t('vallourecServicesManualData.downloadButton')}</p>
        <div>
          <RiDownloadLine size='24px' />
        </div>
      </DownloadButton>
      {selectedFile ?
        <UploadButton onClick={onUploadClick}>
          <p>{t('vallourecServicesManualData.uploadButton')}</p>
          <div>
            <RiUpload2Line size='24px' />
          </div>
          <pre id='jsonData'></pre>
        </UploadButton>
        :
        <DisabledUploadButton>
          <p>{t('vallourecServicesManualData.uploadButton')}</p>
          <div>
            <RiUpload2Line size='24px' />
          </div>
        </DisabledUploadButton>
      }
    </FlexView>
    <LoadingOverlay visible={loading} />
  </FlexView>
}

export default VallourecServicesManualDataPage